import Vue from 'vue';

export default filter => Vue.$http.get('Orders/count', { params: filter });



// WEBPACK FOOTER //
// ./src/services/order/count.js